module.exports = __webpack_public_path__ + "static/media/530.7587807f.png";